import {
  FETCH_GRAPH,
  FETCH_GRAPH_SUCCESS,
  FETCH_GRAPH_FAILURE,
} from "../actions";

const initialState = {
  donationGraph: [],
  loading: true,
  err: null,
  haveData: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GRAPH:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false,
      };
    case FETCH_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        haveData: false,
        donationGraph: action.data,
      };
    case FETCH_GRAPH_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        donationGraph: [],
      };
    default:
      return state;
  }
};
